// extracted by mini-css-extract-plugin
module.exports = {"orderTypes":"OrderTaggingRuleForm_orderTypes__30U3i"};